import { c as _c } from "react/compiler-runtime";
import { ApiCreateGroupDescription } from "@/generated/models/ApiCreateGroupDescription";
import { ApiGroupOwnsNft, ApiGroupOwnsNftNameEnum } from "@/generated/models/ApiGroupOwnsNft";
const COLLECTIONS = [{
  name: "Gradients",
  enum: ApiGroupOwnsNftNameEnum.Gradients
}, {
  name: "Memes",
  enum: ApiGroupOwnsNftNameEnum.Memes
}, {
  name: "Memelab",
  enum: ApiGroupOwnsNftNameEnum.Memelab
}, {
  name: "Nextgen",
  enum: ApiGroupOwnsNftNameEnum.Nextgen
}];
export default function GroupCreateCollections(t0) {
  const $ = _c(9);
  const {
    nfts,
    setNfts
  } = t0;
  let t1;
  if ($[0] !== nfts || $[1] !== setNfts) {
    t1 = collection => {
      const existingCollection = nfts.find(n => n.name === collection);
      if (existingCollection?.tokens.length === 0) {
        setNfts(nfts.filter(n_0 => n_0.name !== collection));
      } else {
        const newCollection = {
          name: collection,
          tokens: []
        };
        const filteredNfts = nfts.filter(n_1 => n_1.name !== collection);
        setNfts([...filteredNfts, newCollection]);
      }
    };
    $[0] = nfts;
    $[1] = setNfts;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const toggleCollection = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div><p className="tw-mb-0 tw-text-base sm:tw-text-lg tw-font-semibold tw-text-iron-50">Collection Access</p><p className="tw-mb-0 tw-mt-0.5 tw-text-sm tw-text-iron-400">Identity must own any token from these collections.</p></div>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== nfts || $[5] !== toggleCollection) {
    t3 = COLLECTIONS.map(collection_0 => {
      const existingCollection_0 = nfts.find(n_2 => n_2.name === collection_0.enum);
      const isSelected = existingCollection_0?.tokens.length === 0;
      return <button key={collection_0.enum} onClick={() => toggleCollection(collection_0.enum)} className={`tw-p-3 tw-rounded-xl tw-border tw-border-solid tw-transition-colors ${isSelected ? "tw-bg-iron-800 tw-border-iron-700 tw-text-iron-50" : "tw-bg-iron-950 tw-border-iron-800 tw-text-iron-400 hover:tw-border-iron-700 hover:tw-text-iron-50"}`}><span className="tw-text-base tw-font-medium">{collection_0.name}</span></button>;
    });
    $[4] = nfts;
    $[5] = toggleCollection;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <div className="tw-p-3 sm:tw-p-5 tw-bg-iron-950 tw-rounded-xl tw-shadow tw-border tw-border-solid tw-border-iron-800">{t2}<div className="tw-mt-2 sm:tw-mt-3"><div className="tw-grid tw-grid-cols-2 tw-gap-2">{t3}</div></div></div>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}